import services from './services.js';
import {
    GetERP_OrderById
} from '@api/orderApi.js';
import NProgress from 'nprogress';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import viewPhoto from 'src/common/js/viewPhoto';
import $http from '$http';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig,
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';

//组件
// import baseInfoForm from 'agent-base-info';

export default {
    mixins: [services],
    components: {

    },
    props: {
        value: {}
    },
    data() {
        return {
            dialogVisible: false,
            OrderData: {
                UnionRentTemplet: {
                    UnionRentList: []
                },
                ApplyPic: []
            },
            status: [{
                "name": "审核通过",
                "id": "6"
            }, {
                "name": "审核不通过",
                "id": "11"
            }],
            IsShow: false,
            PictureVisible: false,
            dialogImageUrl: '',
            transportList: [],
            PayList: [],
            auditFormData: this.getAuditFormData(), //审核需要提交的数据
            changePic: [],
            showPrice: {
                "BookFirstLend": 0,
                "BookTwoLend": 0,
                "BookEquipLend": 0,
                "BookBookLend": 0,
                "LendHiMoney": 0,
                "LendUnionMoney": 0,
                "LendTotal": 0,
                BookFirstOld: 0,
                BookTwoOld: 0

            },
            remarkName: '审核备注'
        }
    },
    computed: {
        isShowClassNum() {
            if (this.OrderData.PackageId != 106 && this.OrderDataProjectType == 2) {
                return true;
            }
            return false;
        },
        isShowJszdByPolicyType() {
            if (this.OrderData.PackageId == 101) {
                return true;
            }
            return false;
        },
        isShowIsFirst() {
            if (this.OrderData.IsFirst > 0) {
                return true;
            }
            return false;
        },
        getAllPrice() {
            return 120;
        },
        isMeetOrder() {
            if (this.OrderData.PackageId == 1001 || this.OrderData.PackageId == 1002 || this.OrderData.PackageId == 1003) {
                return true;
            } else {
                return false
            }
        },
        isPayWayShow() {
            let payWay = $.trim(this.OrderData.PayWay);
            // if (payWay.indexOf("3") > -1) {
            //     return false;
            // } else if (payWay.indexOf("2") > -1) {
            //     return true;
            // }
            if (payWay.indexOf("2") > -1) {
                return true;
            } else {
                return false;
            }

        },
        isShowXgPrice() {
            if ($.trim(this.OrderData.PreOrderPrice).indexOf($.trim(this.OrderData.CurrentOrderPrice)) > -1) {
                return false;
            }
            return true;
        },
        // <!-- PayWay:1支付宝 4微信 5pos机  -->
        payCodeName() {
            if (this.OrderData.PayWay == 1) {
                return "支付凭证单号"
            } else if (this.OrderData.PayWay == 4) {
                return "交易单号"
            } else {
                return ''
            }
        },
        isNeikongAudit() {
            // 内控审核
            //< !--只有 内控列表 / Order / financialListMeetOrder有审核通过与不通过除了1002 1009套餐-- >
            if (this.OrderData.PackageId !== 1002 & this.OrderData.PackageId !== 1009 & this.$route.path == '/Order/financialListMeetOrder') {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        dialogClose() {
            this.dialogVisible = false;
        },
        getAuditFormData() {
            return cloneDeep({
                "Version": 'V6',
                "OrderId": 0,
                "PayMode": 0,
                "SendMode": 0,
                "Bank": "",
                "BankRecord": "",
                "AuditRemark": "", //对外备注
                "AmountCollected": "",
                "OrderStatus": 0,
                "AuditNotes": '', //对内备注
                "TimeStamp": ''
            });
        },
        getErpConfig() {
            return cloneDeep({
                id: ""
            });
        },
        show(options) {
            let opts = $.extend({}, this.getErpConfig(), options);
            this.dialogVisible = true;
            this.auditFormData = this.getAuditFormData();
            this.getPay(8);
            this.getPay(9);
            this.getInfo(opts);
        },

        LookPicture(Url) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: Url,
                    id: ""
                }]
            });
        },
        /*支付，寄送*/
        getPay(type) {
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ParmType: type
            }
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 9) {
                        this.PayList = res.data.Data;
                    } else {
                        this.transportList = res.data.Data;
                    }

                });
            });
        },
        getInfo(options) {
            let opts = $.extend({}, this.getErpConfig(), options);
            let param = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: opts.id
            };
            GetERP_OrderById(param).then(res => {
                util.doResult(this, res, () => {
                    this.OrderData = res.data.Data;
                    this.auditFormData.TimeStamp = this.OrderData.TimeStamp
                    this.auditFormData.OrderId = this.OrderData.OrderId;
                    if (this.OrderData.OrderStatus !== 6 || this.OrderData.OrderStatus !== 11) {
                        this.auditFormData.OrderStatus = null
                    }
                    this.showPrice = util.extendByObj(this.showPrice, this.OrderData.LendInfo)
                    console.log(this.showPrice)
                    this.auditFormData.Bank = this.OrderData.Bank;
                    if (this.OrderData.SendGoods.length > 0) {
                        this.IsShow = true;
                    } else {
                        this.IsShow = false;
                    }
                    if (this.OrderData.PackageId == 10021) {
                        let arr = []
                        for (let i = 0; i < this.OrderData.ProductList.length; i++) {
                            if (this.OrderData.ProductList[i].ProId == 320) {
                                arr.push(this.OrderData.ProductList[i])
                            }
                            if (this.OrderData.ProductList[i].ProId == 0) {
                                arr.push(this.OrderData.ProductList[i])
                            }
                        }

                        this.OrderData.ProductList = arr
                    }
                    for (let i = 0; i < this.OrderData.PayList.length; i++) {
                        if (this.OrderData.PayList[i].VoucherPic !== '') {
                            this.OrderData.PayList[i].changePic = []
                            let picArr = this.OrderData.PayList[i].VoucherPic.split(',');
                            for (let j = 0; j < picArr.length; j++) {
                                this.OrderData.PayList[i].changePic.push({
                                    "Url": picArr[j]
                                });
                            }
                        }
                    }
                    //console.log(this.OrderData.PayList)
                });
            });
        },
        chooseType(val) {
            if (val == 11) {
                this.remarkName = '对外备注'
            } else {
                this.remarkName = '审核备注'
            }

        },
        submit() {

            // var flag = util.checkForm({
            //     ele: this,
            //     rules: [{
            //         name: "收款金额",
            //         value: this.auditFormData.AmountCollected,
            //         more0: true
            //     }]
            // });

            // if (!flag) {
            //     return;
            // }

            this.auditFormData.PayMode = this.OrderData.PayMode;
            this.auditFormData.SendMode = this.OrderData.SendMode;

            // console.log(this.auditFormData)
            //OrderAuditForFinance4  //之前线上财务审核接口
            console.log(this.isNeikongAudit)
            if (this.isNeikongAudit) {
                // 内控审核
                if (this.auditFormData.OrderStatus == null) {
                    this.$notify({
                        title: '警告',
                        message: '请选择审核意见！',
                        type: 'warning'
                    });
                    return;
                }
                if (this.auditFormData.AuditRemark == '' && this.auditFormData.OrderStatus == 11) {
                    this.$notify({
                        title: '警告',
                        message: '请填写对外备注！',
                        type: 'warning'
                    });
                    return;
                }
                if (this.auditFormData.AuditNotes == '' && this.auditFormData.OrderStatus == 11) {
                    this.$notify({
                        title: '警告',
                        message: '请填写对内备注！',
                        type: 'warning'
                    });
                    return;
                }

                this.OrderAuditForFinanceInternal()

            } else {
                this.$confirm('确认通过财务审核吗？', '提示', {
                    type: 'warning'
                }).then(() => {

                    this.auditFormData.OrderStatus = 6
                    this.financialAudit()

                }).catch(() => {});
            }



        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/NeikongAuditList/components/financialAuditView/vm.js